const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

/**
 * Initialize Google Analytics (GA4). Injects gtag script and config when
 * REACT_APP_GA_MEASUREMENT_ID is set. No-op in dev if ID is missing.
 */
export function init() {
  if (!GA_ID || typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  gtag("config", GA_ID);
}

/**
 * Send a page_view event (for SPA route changes).
 * @param {string} path - page_path (e.g. location.pathname)
 * @param {string} [title] - page_title (e.g. document.title)
 */
export function trackPageView(path, title) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title || document?.title || "",
  });
}

/**
 * Send a custom event to GA4.
 * @param {string} eventName - e.g. 'hero_search_submit', 'cta_click'
 * @param {Record<string, unknown>} [params] - event parameters (no PII)
 */
export function trackEvent(eventName, params = {}) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", eventName, params);
}
